export function initDesktopNavMenu() {
  document
    .querySelectorAll<HTMLElement>('.nb-item--has-children')
    .forEach(applyMenuItemIteraction);

  function applyMenuItemIteraction($el: HTMLElement) {
    let timer: number;

    $el.addEventListener('mouseenter', evt => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        document
          .querySelectorAll('.nb-item--has-children.s--hover')
          .forEach(el => el.classList.remove('s--hover'));

        (evt.target as HTMLElement).classList.add('s--hover');
      }, 150);
    });

    $el.addEventListener('mouseleave', evt => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        (evt.target as HTMLElement).classList.remove('s--hover');
      }, 500);
    });
  }
}
